/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const markEmailsAsUnreadDataSchema = z.object({
	emailIds: z.array(z.string()),
})

export type MarkEmailsAsUnreadDataSchema = z.infer<typeof markEmailsAsUnreadDataSchema>
